<template>
  <div id="expensesApprovedComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-4">
        <v-flex>
        <v-dialog v-model="dialog" scrollable max-width="700px" persistent>
        <v-card :items="viewNF">
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('workflowValidation.approb')}}<strong>( {{viewNF.receipt_type.name}} )</strong></h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.date')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.date}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.category')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.gst_categories.name ? viewNF.gst_categories.name : ''}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.country')}}</strong></p>
                    <p class="text-sm-justify">{{viewNF.country.descripcion}}</p>
                  </v-flex>
                  <!-- <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.isRefund')}}</strong></p>
                    <p class="text-sm-left">{{expenseItem.is_refund === 1 ? $t('general.yes') : $t('general.no')}}</p>
                  </v-flex> -->
                  <v-flex xs12>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.description')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.description}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.currency')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.currency.c_Moneda}} - {{viewNF.currency.descripcion}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.exchangeRate')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.exchange}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.subtotal')}}</strong></p>
                    <p class="text-sm-left">${{viewNF.subtotal}} {{viewNF.currency.c_Moneda}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.total')}}</strong></p>
                    <p class="text-sm-left">${{viewNF.total}} {{viewNF.currency.c_Moneda}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.formaPago')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.sat_forma_pago.descripcion}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.folioRef')}}</strong></p>
                    <p class="text-sm-left">{{viewNF.folio}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.comment')}}</strong></p>
                    <p class="text-sm-justify">{{viewNF.comment}}</p>
                  </v-flex>
                </v-flex>
                <v-flex xs6 layout v-if="dataURL">
                  <v-flex xs12>
                    <a v-if="!isPDF(dataURL)" @click="openPDF()">
                      <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                    </a>
                    <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                      <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                    </v-btn>
                    <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              round
              flat
              @click="close"
              >
              {{$t('general.close')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-flex>
      <v-flex>
          <v-dialog persistent scrollable v-model="dialogFiscal" max-width="600px">
            <v-card :items="viewF">
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{ $t('workflowValidation.approb')}} <span>( {{viewF.receipt_type.name}} )</span></h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>UUID</strong></p>
                        <p class="text-sm-left">{{viewF.uuid}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.date')}}</strong></p>
                        <p class="text-sm-left">{{viewF.date}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.category')}}</strong></p>
                        <p class="text-sm-left">{{viewF.gst_categories.name ? viewF.gst_categories.name : ''}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.country')}}</strong></p>
                        <p class="text-sm-justify">{{viewF.country.descripcion}}</p>
                      </v-flex>
                      <v-flex xs12>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.description')}}</strong></p>
                        <p class="text-sm-left">{{viewF.description}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.currency')}}</strong></p>
                        <p class="text-sm-left">{{viewF.currency.c_Moneda}} - {{viewF.currency.descripcion}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.exchangeRate')}}</strong></p>
                        <p class="text-sm-left">{{viewF.exchange}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.subtotal')}}</strong></p>
                        <p class="text-sm-left">${{viewF.subtotal}} {{viewF.currency.c_Moneda}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.total')}}</strong></p>
                        <p class="text-sm-left">${{viewF.total}} {{viewF.currency.c_Moneda}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.formaPago')}}</strong></p>
                        <p class="text-sm-left">{{viewF.sat_forma_pago.descripcion}}</p>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.folioRef')}}</strong></p>
                        <p class="text-sm-left">{{viewF.folio}}</p>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs6>
                        <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.comment')}}</strong></p>
                        <p class="text-sm-justify">{{viewF.comment}}</p>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="success darken-1"
                  round
                  flat
                  v-if="viewF.receipt_type.id == 1"
                  :loading="loadingXML"
                  @click="downloadXML"
                >
                  {{$t('general.downloadXML')}}
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close">
                  {{ $t('general.close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="expenses"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="grey lighten-3" @click="props.expanded = !props.expanded">
            <td class="font-weight-black" style="max-width: 30px">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="!props.expanded"
                    v-on="on"
                    color="primary"
                    >
                    mdi-chevron-down
                  </v-icon>
                  <v-icon
                    v-else
                    v-on="on"
                    color="primary"
                    >
                    mdi-chevron-up
                  </v-icon>
                </template>
                <span>
                  {{!props.expanded ?
                    $t('general.extend') : $t('general.collapse')}}
                </span>
              </v-tooltip>
            </td>
            <td class="font-weight-black" width="60px">{{props.item.id}}</td>
            <td class="font-weight-black text-sm-center">{{props.item.user.name}}</td>
            <td class="font-weight-black text-sm-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="vertical-align: middle"
                    v-if="props.item.is_petty_cash === 1"
                    class="primary--text"
                    v-on="on"
                  >stars</v-icon>
                </template>
                <span>{{ $t('expenses.pettyExpense') }}</span>
              </v-tooltip>
              {{props.item.description}}
            </td>
            <td class="font-weight-black text-sm-center">{{props.item.project.name}}</td>
            <td class="font-weight-black text-sm-center">{{props.item.start_date}}</td>
            <td class="font-weight-black text-sm-center">{{props.item.end_date}}</td>
            <td class="font-weight-black text-sm-center">{{props.item.gst_expenses_items.length}}</td>
            <td class="font-weight-black text-sm-center">
              {{ sumValuesExpensesItems(props.item.gst_expenses_items) | formatCurrency }}
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-layout>
              <v-flex xs12>
                <h2 class="primary--text text-sm-left ml-3 mt-2">{{$t('general.expenseItems')}}:</h2>
              </v-flex>
            </v-layout>
            <v-layout v-if="props.item.gst_expenses_items.length === 0">
              <v-flex xs12>
                <p class="text-sm-left ml-4">{{$t('history.noItem')}}</p>
              </v-flex>
            </v-layout>
            <v-layout v-if="props.item.gst_expenses_items.length !== 0">
              <v-flex xs12>
                <table width="100%">
                  <thead>
                    <th class="text-sm-center font-weight-black">#</th>
                    <th class="text-sm-center font-weight-black">{{$t('general.description')}}</th>
                    <th class="text-sm-center font-weight-black">{{$t('general.subtotal')}}</th>
                    <th class="text-sm-center font-weight-black">{{$t('general.total')}}</th>
                    <th class="text-sm-center font-weight-black">{{$t('general.comment')}}</th>
                    <th class="text-sm-center font-weight-black">{{$t('general.actions')}}</th>
                  </thead>
                  <tr v-for="item of props.item.gst_expenses_items" :key="item.id">
                    <td class="text-sm-center">{{item.id}}</td>
                    <td class="text-sm-center">{{item.description}}</td>
                    <td class="text-sm-center">{{item.subtotal | formatCurrency}}</td>
                    <td class="text-sm-center">{{item.total | formatCurrency}}</td>
                    <td class="text-sm-center">{{item.comment}}</td>
                    <td class="text-sm-center">
                      <v-btn
                        v-if="item.gst_receipt_types_id === 2"
                        small
                        outline
                        round
                        color="primary"
                        icon
                        @click="viewExpensesNF(item)"
                      >
                        <v-icon small>search</v-icon>
                      </v-btn>
                      <v-btn
                        v-else
                        small
                        outline
                        round
                        color="primary"
                        icon
                        @click="viewExpensesF(item)"
                      >
                        <v-icon small>search</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-card>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    userloggeds: {},
    search: '',
    dataURL: null,
    expenses: [],
    userItems: [],
    viewNF: {
      gst_categories: [],
      country: [],
      currency: [],
      sat_forma_pago: [],
      receipt_type: []
    },
    viewF: {
      gst_categories: {},
      country: {},
      currency: {},
      sat_forma_pago: {},
      sat_metodo_pago: {},
      receipt_type: {}
    },
    itemsNew: {},
    rowsPerPageItems: [10, 15, 25],
    pagination: {
      rowsPerPage: 15,
      sortBy: 'date_sent',
      descending: true
    },
    dialog: false,
    dialogFiscal: false,
    dialogNew: false,
    editedIndex: -1,
    loadingItems: true
  }),
  created () {
    this.getLogged()
    // this.login()
    // this.get()
    // this.item()
  },
  computed: {
    heading () {
      return this.$t('general.approbed')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-check-circle fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: '',
          align: 'center',
          sortable: false
        },
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true
        },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'start_date',
          sortable: true
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'end_date',
          sortable: true
        },
        {
          text: this.$t('general.expenseItems'),
          align: 'center',
          value: 'items.length',
          sortable: true
        },
        {
          text: this.$t('general.totalAmount'),
          align: 'center',
          value: 'items.length',
          sortable: true
        }
      ]
    }
  },
  watch: {
    userloggeds () {
      this.get()
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  methods: {
    downloadXML () {
      this.loadingXML = true
      this.$store.dispatch('downloadXML', {
        event: {
          context: this,
          fileId: this.viewF.gst_expenses_items_files[0].files_id,
          description: this.viewF.description
        }
      })
    },
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userloggeds = this.$store.state.userLogged
      }
    },
    get () {
      this.$emit('get', {
        user: this.userloggeds,
        context: this
      })
    },
    // login () {
    //   this.$emit('logged', {
    //     context: this
    //   })
    // },
    viewNewItems (newItem) {
      this.itemsNew = Object.assign({}, newItem)
      this.dialogNew = true
      /* this.loading = false
      this.disabled = false */
    },
    viewExpensesNF (item) {
      this.viewNF = Object.assign({}, item)
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: this.viewNF.gst_expenses_items_files[0].files_id
        }
      })
      this.dialog = true
    },
    viewExpensesF (item) {
      this.viewF = Object.assign({}, item)
      this.dialogFiscal = true
    },
    close () {
      this.dialog = false
      this.dialogFiscal = false
      this.dataURL = false
    },
    closeNewItems () {
      this.dialogNew = false
    },
    isPDF (data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF () {
      var tab = window.open()
      tab.document.write('<body style="margin: 0;"> <iframe src="' + this.dataURL + '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>')
    },
    sumValuesExpensesItems (items) {
      let totalExpense = 0
      if (items.length > 0) {
        let sum = a => a.reduce((x, y) => x + y)
        let totalItems = sum(items.map(x => Number(x.total)))
        totalExpense = totalItems
      }
      return totalExpense
    }
  }
}
</script>
<style scoped>
.borde {
  border: 8px solid rgba(16, 197, 25, 0.89) !important;
  border-radius: 10px !important;
}
.colores {
  background-color: rgb(16, 197, 25) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user.expensesApproved.component.vue